// Funões de utilidades gerais para ser usado em qualquer lugar

const moment = require("moment");

 
export const utils = {
 
    formatDataShort(dateTime) {
        let date = new Date(dateTime);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        let stringDate =
            (String(day).length == 1 ? "0" : "") +
            day +
            "/" +
            (String(month).length == 1 ? "0" : "") +
            month +
            "/" +
            String(year);

        return stringDate;
    },

    formatDataLong(dateTime) {
        let date = new Date(dateTime);
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        let hour = date.getHours();
        let min = date.getMinutes();
        let sec = date.getSeconds();

        let stringDate =
            (String(day).length == 1 ? "0" : "") +
            day +
            "/" +
            (String(month).length == 1 ? "0" : "") +
            month +
            "/" +
            String(year) +
            " " +
            (String(hour).length == 1 ? "0" : "") +
            hour +
            ":" +
            (String(min).length == 1 ? "0" : "") +
            min +
            ":" +
            (String(sec).length == 1 ? "0" : "") +
            sec;
        return stringDate;
    },

    formatData(dateTime, ln = "br") {
        const now = moment(new Date()); // Data de hoje
        const past = moment(dateTime); // Outra data no passado
        const duration = moment.duration(now.diff(past));

        let time = "";

        if (duration._data.years) {
            time =
                duration._data.years > 1 ?
                duration._data.years + (ln == "br" ? " anos" : " years") :
                ln == "br" ?
                "um ano" :
                "a year";
            return time;
        }

        if (duration._data.months) {
            time =
                duration._data.months > 1 ?
                duration._data.months + ( " meses") : "1 mês" ;
            return time;
        }

        if (duration._data.days) {
            time =
                duration._data.days > 1 ?
                duration._data.days + ( " dias" ) :  "1 dia" ;
            return time;
        }

        if (duration._data.hours) {
            time =
                duration._data.hours > 1 ?
                duration._data.hours + (" h") : "1 h"  ;
            return time;
        }

        if (duration._data.minutes) {
            time =
                duration._data.minutes > 1 ?
                duration._data.minutes + ( " min" ) : " ...";
            return time;
        }

        if (duration._data.seconds || duration._data.milliseconds) {
            time =  "..."  
            return time;
        }
    }, 
};